import React, { createContext, useState } from "react";

interface ResetPasswordActionContextType {
  email: any;
  setEmail: (email: any) => void;
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
}

export const ResetPasswordActionContext = createContext<ResetPasswordActionContextType>({
  email: null,
  setEmail: () => {},
  showModal: false,
  setShowModal: () => {},
});

interface ResetPasswordActionProviderProps {
  children: React.ReactNode;
}

export const ResetPasswordActionProvider: React.FC<ResetPasswordActionProviderProps> = ({
  children,
}) => {
  const [email, setEmail] = useState<any>(null);
  const [showModal, setShowModal] = useState(false);

  const value = {
    email,
    setEmail,
    showModal,
    setShowModal
  };
  return (
    <ResetPasswordActionContext.Provider value={value}>
      {children}
    </ResetPasswordActionContext.Provider>
  );
};
